import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import api from '../../api/api';
import uri from '../../variables/uri';
import history from '../../history';
import lockImg from '../../images/lock.png';
import correctImg from '../../images/correct.png';
import incorrectImg from '../../images/incorrect.png';
import ManageDoaHeader from './ManageDoaHeader';
import ReactExport from "react-data-export";
import { setLoading } from '../../actions/authAction';
import ConfirmDialogModal from '../modals/ConfirmDialogModal';
import AlertModal from '../modals/AlertModal';
import NoteModal from '../modals/NoteModal';
import Modal from 'react-modal';
import FormInput from "../forms/FormInput";
import Pagination from 'rc-pagination';
import util from '../../functions/Utilities';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        border: 'none',
        borderRadius: '10px',
        padding: '32px',
        fontFamily: 'Prompt',
        maxHeight: '80%',
        minWidth: '500px',
        overflowY: 'scroll',
        zIndex: 9
    },
    overlay: {
        background: 'rgba(0,0,0,0.5)'
    }
};
class ManageDoa extends React.Component {
    state = {
        subjectList: [],
        topicList: [],
        conditionList: [],
        permissionList: [],
        permissionArr: [],
        permissionSelection: [],
        permissionId: '',
        selected: '',
        hilight: '',
        hide: true,
        isOpenEdit: false,
        isOpenAdd: false,
        isOpenMessage: false,
        messageConfirm: '',
        textConfirm: '',
        message: '',
        typeAlert: 1,
        selectedTopic: {},
        action: '',
        selectedSubject: '',
        typeId: '',
        selectedTopicList:[],
        isDownloadExcel:false,
        isDownloadTemplate:false,
        requestNo:"",
        requestID:"",
        requestDate:"",
        requestUserId:"",
        requestNote:"",
        excelDataList:[],
        permissionWidth:0,
        cardWidth:490,
        isOpenRef:false,
        searchNote:'',
        searchReqNo:'',
        referDataList:[],
        referOriginalDataList:[],
        currentPage: 1,
        postsPerPage: 10,
        valueWidth:68,
        valueHeight:30
    }

    componentDidMount = async () => {
        if (!this.props.auth.isAuthen) {
            history.push(`/home/${localStorage.getItem('username')}`)
        } else {
           this.props.setLoading(true);
           try {
                let editor = this.checkRoleEditBook() ? 'true' : 'false';
                const topicResponse = await api.get(`${uri.GET_TOPIC_LIST_BY_BOOK}?BookReleaseId=${this.props.book.BookReleaseId}&Editor=${editor}`);
                if (topicResponse.status === 200 ) {
                    this.setState({ topicList: topicResponse.data.filter(item => item.SubjectTypeTitle === this.props.type) });
                }
                let countValue = 0;
                let countRemark = 0;
                this.state.topicList.forEach(elm=>{
                    if(elm.Value !== null){
                        if(elm.Value.length > 10){
                            if(countValue === 0 || elm.Value.length > countValue){
                                countValue = elm.Value.length;
                            }
                        }
                    }
                    if(elm.Comments !== null){
                        if(elm.Comments.length > 53){
                            if(countRemark === 0 || elm.Comments.length > countRemark){
                                countRemark = elm.Comments.length;
                            }
                        }
                    }
                }); 
                if(countValue>0){
                    this.setState({valueWidth: countValue*5.2})
                }
                
                if(countRemark>0){
                    if(countRemark>53){
                        this.setState({valueHeight: 39})
                    }
                    if(countRemark>106){
                        this.setState({valueHeight: 50})
                    }
                    if(countRemark>160){
                        this.setState({valueHeight: 65})
                    }
                    if(countRemark>216){
                        this.setState({valueHeight: 81})
                    }
                    if(countRemark>273){
                        this.setState({valueHeight: 95})
                    }
                    
                }
            } catch (ex) {
                this.setState({ topicList: [], conditionList: [] });
            }
            //this.setState({ topicList: this.props.topicList });
            let uniqSubject = _.uniqBy(this.state.topicList, 'SubjectTitle');
            let filteredTopic = this.state.topicList;
            //let filteredTopic = _.sortBy(this.state.topicList, 'TopicID');
            if (this.props.doa.levelOne !== '' && this.props.doa.levelOne !== 'Please select Level 1') {
                uniqSubject = uniqSubject.filter(item => item.SubjectTitle === this.props.doa.levelOne);
            }
            if (this.props.doa.levelTwo !== '' && this.props.doa.levelTwo !== 'Please select Level 2') {
                const found = this.state.topicList.find(item => item.TopicTitle === this.props.doa.levelTwo);
                if (found) {
                    filteredTopic = filteredTopic.filter(item => (item.TopicNo.includes(found.TopicNo + '.') || item.TopicNo === found.TopicNo));
                }
            }
            this.setState({ subjectList: uniqSubject, topicList: filteredTopic, conditionList: this.props.conditionList, selectedTopicList:[]});
            if (uniqSubject.length === 1) {
                this.onSubjectSelected(uniqSubject[0]);
                this.setState({ selected: uniqSubject[0].SubjectTitle });
            }
            if (this.props.type === 'อำนาจทั่วไป / General') this.setState({ typeId: 1 })
            else if (this.props.type === 'อำนาจเฉพาะ / Speciality') this.setState({ typeId: 2 })
            else if (this.props.type === 'พิเศษ / Extra') this.setState({ typeId: 3 })

            if(!this.checkRoleEditBook()){
                let col = this.state.cardWidth - 190;
                this.setState({ cardWidth:  col});
            }
            this.props.setLoading(false);
        }
    }

    checkRoleEditBook(){
        if(this.props.auth.isAdmin){
            return true;
        }
        if(this.props.auth.isEditor){
            let havePermis = false;
            for (let i = 0; i < this.props.auth.bookGroup.length; i++) {
                if(this.props.book.BookCode.toLowerCase() === this.props.auth.bookGroup[i].toLowerCase() || this.props.auth.bookGroup[i].toLowerCase() === "all"){
                    havePermis = true;
                }
            }
            if(havePermis){
                return true;
            }else{
                return false;
            }
        }
        return false;
    }

    onBackPressed() {
        history.goBack();
    }

    checkRemarkForHeight = (str) => {
        if(str != null){
            if(str.length>0){
                if(str.length>273){
                    return 95;
                }
                else if(str.length>216){
                    return 81;
                }
                else if(str.length>160){
                    return 65;
                }
                else if(str.length>106){
                    return 50;
                }
                else if(str.length>53){
                    return 39;
                }
            }
        }
        
        return 30;
    }

    onSubjectSelected = async (subject) => {
        if (this.state.permissionId !== subject.PermissionGroupID) {
            const response = await api.get(`${uri.GET_PERMISSION_LIST}?PermissionGroupID=${subject.PermissionGroupID}`);
            const permissionArr = [];
            let width = 0;
            response.data.forEach(element => {
                permissionArr.push(element.PermissionName !== null ? element.PermissionName : element.PermissionValue);
                width = element.PermissionName !== null ? element.PermissionName.length * 10 < 30 ? width + 30 : width + (element.PermissionName.length * 10 ):  width +(element.PermissionValue.length * 10);
            });
            let permissionSelection = permissionArr;
            permissionSelection.push('Please select');
            permissionSelection = permissionSelection.reverse();
            
            this.setState({ selected: subject.SubjectTitle, permissionId: subject.PermissionGroupID, permissionList: _.sortBy(response.data, 'PermissionSequence').reverse(), permissionArr, permissionSelection ,permissionWidth:width});
        } else if (this.state.selected === subject.SubjectTitle) {
            this.setState({ selected: '' });
        } else {
            this.setState({ selected: subject.SubjectTitle });
        }
       // document.getElementById(subject.KeyTmp).scrollIntoView();
    }

    assignText(obj, type) {
        const { ApprovalText, SignText, ReportText } = obj;

        switch (type) {
            case 'ASR':
                return 'อ/ล/ท'
            case 'AS':
                return 'อ/ล'
            case 'SR':
                return 'ล/ท'
            case 'AR':
                return 'อ/ท'
            case 'A':
                if (ApprovalText !== null) return ApprovalText
                return 'อ'
            case 'S':
                if (SignText !== null) return SignText
                return 'ล'
            case 'R':
                if (ReportText !== null) return ReportText
                return 'ท'
            default:
                return;
        }
    }

    hilight(hilight) {
        if (this.state.hilight === hilight) {
            this.setState({ hilight: '' });
        } else {
            this.setState({ hilight });
        }
    }

    header() {
        return (
            <div style={{ height: '30px', border: '1px solid #ddd' }} className="flex-h flex-between bg-grey">
                <div className="flex-h flex-center" style={{ minWidth: '202px' }} >
                    <h4 className="ml-8 text-bold">อำนาจดำเนินการ</h4>
                </div>
                
                {<div className="flex-h">
                    
                    {this.state.permissionList.map(permission => {
                        return (
                            <div key={permission.PermissionID} className="pl-8 pr-8 flex-h flex-center" style={{ width: permission.PermissionName !== null ? 10 * permission.PermissionName.length<30?'30px': `${10 * permission.PermissionName.length}px` : '30px', height: '30px', borderLeft: '1px solid #ddd' }}>
                                <h4 className="text-bold" style={{ lineHeight: '1', textAlign: 'center' }}>{permission.PermissionName !== null ? permission.PermissionName : permission.PermissionValue}</h4>
                            </div>
                        );
                    })}
                    <div className="pl-8 pr-8 flex-h flex-center" style={{ width: '300px', height: '30px', borderLeft: '1px solid #ddd' }}>
                        <h4 className="ml-8 text-bold">Remark</h4>
                    </div>
                    {this.checkRoleEditBook()&&<div className="pl-2 flex-h flex-center" style={{ width: '43px', height: '30px', borderLeft: '1px solid #ddd' }}>
                        <h4 className="text-bold">Status</h4>
                    </div>}
                    {this.checkRoleEditBook()&&<div className="pl-2 flex-h flex-center" style={{ width: '67px', height: '30px', borderLeft: '1px solid #ddd', textAlign: 'center' }}>
                        <h4 className="text-bold">Updated date</h4>
                    </div>}
                    {this.checkRoleEditBook()&&<div className="pl-2 flex-h flex-center" style={{ width: '80px', height: '30px', borderLeft: '1px solid #ddd' }}>
                        <h4 className="text-bold">Editor</h4>
                    </div>}
                    <div className="flex-h flex-center" style={{ width: '50px', height: '30px', borderLeft: '1px solid #ddd' }}>
                            <h4 className="text-bold">Type</h4>
                    </div>
                    <div className="flex-h flex-center" style={{ width: '60px', height: '30px', borderLeft: '1px solid #ddd' }}>
                        <h4 className="text-bold">Operation</h4>
                    </div>
                    <div className="flex-h flex-center" style={{ width: `${this.state.valueWidth}px`, height: '30px', borderLeft: '1px solid #ddd' }}>
                        <h4 className="text-bold">Value</h4>
                    </div>
                </div>
                }
            </div>
        );
    }
    
    handleCheckboxChange = (e,key)=>{
        let topicNo = "";
        let subjectId = 0;
        this.state.topicList.find(obj => {
            if (obj.KeyTmp === key) {
                topicNo = obj.TopicNo
                subjectId = obj.SubjectID
                return false
            } else {
                return false
            }
        });
        this.handleCheckboxChild(topicNo,subjectId,e.target.checked);
    }

    handleCheckboxChild(topicNo,subjectId,newValue){
        let dtList = this.state.topicList.filter(item=>item.SubjectID === subjectId);
        let digitInput = topicNo.split('.').join('').length;
        let isCurrent = false;
        let res =[];
        let isSuccess = false;
        dtList.find(item=>{
            if(item.SubjectID === subjectId && !isSuccess && !item.IsLocked){
                if(topicNo===item.TopicNo && !isCurrent){
                    isCurrent = true;
                    res.push(item.KeyTmp);
                    return false;
                }else if (!isCurrent)
                {
                    return false;
                } 
                let digitTarget = item.TopicNo.split('.').join('').length;
                if (digitTarget > digitInput || (digitTarget === digitInput && item.TopicNo === topicNo)){
                    // if(item.TopicNo.indexOf(".") < 0 && topicNo.indexOf(".") < 0){
                    //     if(parseInt(item.TopicNo)> parseInt(topicNo)){

                    //     }else{
                    //         res.push(item.KeyTmp);
                    //     }
                    // }else{
                    //     res.push(item.KeyTmp);
                    // }
                    if(digitInput===1 && item.TopicNo.split('.')[0].length>1){

                    }else{
                        res.push(item.KeyTmp);
                    }
                    return false;
                }
                else if(digitTarget === digitInput)
                {
                    isSuccess = true;
                    return false;
                }
                return false;
            }else{
                return false;
            }
        });
        let checkedList = [];
        let newTopicList = this.state.topicList.map(obj => {
            if(res.filter(item=>item === obj.KeyTmp).length>0){
                obj.IsChecked = newValue
                if(obj.IsChecked === true){
                    checkedList.push(obj);
                    //checkedList.push({TopicRefID:obj.TopicRefID,ConditionRefID:obj.ConditionRefID, TopicID:obj.TopicID,CondID:obj.CondID,CondDetailID:obj.CondDetailID,SubjectID:obj.SubjectID,SubjectTypeTitle:obj.SubjectTypeTitle,TopicNo:obj.TopicNo})
                }
                return obj
            }else{
                if(obj.IsChecked === true){
                    checkedList.push(obj);
                    //checkedList.push({TopicRefID:obj.TopicRefID,ConditionRefID:obj.ConditionRefID, TopicID:obj.TopicID,CondID:obj.CondID,CondDetailID:obj.CondDetailID,SubjectID:obj.SubjectID,SubjectTypeTitle:obj.SubjectTypeTitle,TopicNo:obj.TopicNo})
                }
                return obj
            }
        });
        this.setState({topicList:newTopicList, selectedTopicList:checkedList});
        
    }

    isSubjectAllSelected = (subjectId) => {
        const topics = this.state.topicList.filter(topic => topic.SubjectID === subjectId && !topic.IsLocked);
        if (topics.length === 0) return false;
        return topics.every(topic => topic.IsChecked);
    }

    hasSelectableTopic = (subjectId) => {
        return this.state.topicList.some(topic => topic.SubjectID === subjectId && !topic.IsLocked);
    }

    onToggleSelectAll = (e, subjectId) => {
        e.stopPropagation();
        const shouldSelectAll = !this.isSubjectAllSelected(subjectId);
        const updatedTopicList = this.state.topicList.map(topic => {
            if (topic.SubjectID === subjectId && !topic.IsLocked) {
                return { ...topic, IsChecked: shouldSelectAll };
            }
            return topic;
        });
        const selectedTopicList = updatedTopicList.filter(topic => topic.IsChecked);
        this.setState({ topicList: updatedTopicList, selectedTopicList });
    }

    assignFunc = (obj, type, i, permission) => {
        return (
            <div key={i} className="flex-h flex-center" style={{ width: permission.PermissionName !== null ?10 * permission.PermissionName.length<30?'30px':  `${10 * permission.PermissionName.length}px` : '30px', borderLeft: '1px solid #ddd' }}>
                <h5>{this.assignText(obj, type)}</h5>
            </div>
        )
    }

    onClickLock = (str,strDate)=>{
        this.setState({ isOpenMessage: true, message:'Checkout By : '+ str+'<br>Checkout Date : ' + strDate, typeAlert:2});
    }

    onEditTopic = () => {
        this.setState({ isDownloadTemplate:false,isDownloadExcel:false});
        if(this.state.selectedTopicList.length>0){
            this.setState({ isOpenEdit: true, isOpenAdd:false, textConfirm:'Do you want to checkout Doa?', messageConfirm:'Checkout Doa'});
        }else{
            this.setState({ isOpenMessage: true, message:'Please select topic.', typeAlert:2});
            //this.setState({ isOpenEdit: false, isOpenAdd:true, textConfirm:'Would you like to download a template to add Doa?', messageConfirm:'Template Doa'});
        }
        
    }
    
    onCloseConfirm = () =>{
        this.setState({ isOpenEdit: false, isOpenAdd: false, isOpenRef: false, referDataList: [], referOriginalDataList: [], searchNote: '', searchReqNo: ''});
    }

    onCloseAlert=()=>{
        this.setState({ isOpenMessage: false, message:'',isDownloadExcel:false});
    }

    onDownloadTemplateAdd=()=>{
        this.setState({ isOpenEdit: false, isOpenAdd: false,isDownloadTemplate:true});
        //
    }

    onDownloadExcel =()=>{ 
        this.props.setLoading(false);
        this.setState({ isOpenMessage: true, message:'Download successfully.', typeAlert:1, isDownloadExcel:true});
    }
    
    onSubmit = async (txt) =>{
        this.setState({ isOpenEdit: false, isOpenAdd: false});
        this.props.setLoading(true);
        try{
            var body = {
                BookCode:this.props.book.BookCode,
                UserId:localStorage.getItem('username'),
                UserName:this.props.auth.name,
                DoaList: this.state.selectedTopicList,
                Note: txt
            }
            var verifyTopic = await api.post(uri.GET_VERIFY_TOPIC, body);
            if (verifyTopic.status === 200) {
                if(verifyTopic.data.ResponseCode==="99"){
                    this.props.setLoading(false);
                    this.setState({ isOpenMessage: true, message:verifyTopic.data.ResponseMsgTh, typeAlert:3});
                }
                else if(verifyTopic.data.ResponseCode==="01"){
                    this.props.setLoading(false);
                    this.setState({ isOpenMessage: true, message:verifyTopic.data.ResponseMsgTh, typeAlert:2});
                }
                else if(verifyTopic.data.ResponseCode==="00"){
                    this.setState({ 
                        requestNo: verifyTopic.data.ResponseData.RequestNo,
                        requestID: verifyTopic.data.ResponseData.RequestID,
                        requestDate: verifyTopic.data.ResponseData.RequestDate,
                        requestUserId: verifyTopic.data.ResponseData.RequestUserId,
                        excelDataList:verifyTopic.data.ResponseData.DoaList,
                        requestNote: txt
                    });
                    this.onDownloadExcel();
                    this.componentDidMount();
                }
                //show success?
            }
        }catch (ex) {
            this.props.setLoading(false);
            this.setState({ isOpenMessage: true, message:ex.Message, typeAlert:3});
        }
        
    }

    convertNullToStringEmpty(str){
        if(str === undefined || str === null){
            return "";
        }else{
            return str;
        }
    }

    downloadExcelForEdit() {
        let filename = 'DOA ' +this.props.book.BookCode;
        let multiDataSet =[{
            columns: [
                {title: "RequestNo", width: {wpx: 90}},
                {title: "RequestID", width: {wpx: 90}},
                {title: "RequestDate", width: {wpx: 90}},
                {title: "RequestUserId", width: {wpx: 90}},
                {title: "RequestNote", width: {wpx: 90}},
            ],
            data:[
                [
                    {value: this.state.requestNo},
                    {value: this.state.requestID},
                    {value: this.state.requestDate},
                    {value: this.state.requestUserId},
                    {value: this.state.requestNote}
                ],
                [
                    {value: "ReferenceID", style: {font: {bold: true}}},
                    {value: "Action", style: {font: {bold: true}}},
                    {value: "Book", style: {font: {bold: true}}},
                    {value: "Subject", style: {font: {bold: true}}},
                    {value: "SubjectTypeCode", style: {font: {bold: true}}},
                    {value: "SubjectType", style: {font: {bold: true}}},
                    {value: "TopicNo", style: {font: {bold: true}}},
                    {value: "TopicTitle", style: {font: {bold: true}}},
                    {value: "ConditionTitle", style: {font: {bold: true}}},
                    {value: "Type", style: {font: {bold: true}}},
                    {value: "Operation", style: {font: {bold: true}}},
                    {value: "Value", style: {font: {bold: true}}},
                    {value: "ApproveLevel", style: {font: {bold: true}}},
                    {value: "ApproveLevelText", style: {font: {bold: true}}},
                    {value: "SignLevel", style: {font: {bold: true}}},
                    {value: "SignLevelText", style: {font: {bold: true}}},
                    {value: "ReportLevel", style: {font: {bold: true}}},
                    {value: "ReportLevelText", style: {font: {bold: true}}},
                    {value: "Remark", style: {font: {bold: true}}},
                    {value: "Comment", style: {font: {bold: true}}}
                ]
            ]    
        }];
        this.state.excelDataList.map(obj=>{
            let arr = [
                {value:obj.ConditionRefID !== undefined && obj.ConditionRefID !== null ? obj.ConditionRefID : obj.TopicRefID},
                {value:""},
                {value:this.convertNullToStringEmpty(obj.BookCode)},
                {value:this.convertNullToStringEmpty(obj.SubjectTitle)},
                {value:this.convertNullToStringEmpty(obj.SubjectTypeID)},
                {value:this.convertNullToStringEmpty(obj.SubjectTypeTitle)},
                {value:this.convertNullToStringEmpty(obj.TopicNo)},
                {value:this.convertNullToStringEmpty(obj.TopicTitle)},
                {value:this.convertNullToStringEmpty(obj.CondTitle)},
                {value:this.convertNullToStringEmpty(obj.Type)},
                {value:this.convertNullToStringEmpty(obj.Operation)},
                {value:this.convertNullToStringEmpty(obj.Value)},
                {value:this.convertNullToStringEmpty(obj.Approval)},
                {value:this.convertNullToStringEmpty(obj.ApprovalText)},
                {value:this.convertNullToStringEmpty(obj.Sign)},
                {value:this.convertNullToStringEmpty(obj.SignText)},
                {value:this.convertNullToStringEmpty(obj.Report)},
                {value:this.convertNullToStringEmpty(obj.ReportText)},
                {value:this.convertNullToStringEmpty(obj.Remark)},
                {value:this.convertNullToStringEmpty(obj.Comments)}
            ];
            multiDataSet[0].data.push(arr);
        });
 
      return (
        <ExcelFile hideElement={true} filename={filename}>
                <ExcelSheet dataSet={multiDataSet} name="Doa"/>
            </ExcelFile>
      );
    }

    downloadExcelForAdd(){
        let filename = 'DOA ' +this.props.book.BookCode;
        let multiDataSet =[{
            columns: [
                {title: "RequestNo", width: {wpx: 90}},
                {title: "RequestID", width: {wpx: 90}},
                {title: "RequestDate", width: {wpx: 90}},
                {title: "RequestUserId", width: {wpx: 90}},
            ],
            data:[
                [
                    {value: ""},
                    {value: ""},
                    {value: ""},
                    {value: localStorage.getItem('username')}
                ],
                [
                    {value: "ReferenceID", style: {font: {bold: true}}},
                    {value: "Action", style: {font: {bold: true}}},
                    {value: "Book", style: {font: {bold: true}}},
                    {value: "Subject", style: {font: {bold: true}}},
                    {value: "SubjectTypeCode", style: {font: {bold: true}}},
                    {value: "SubjectType", style: {font: {bold: true}}},
                    {value: "TopicNo", style: {font: {bold: true}}},
                    {value: "TopicTitle", style: {font: {bold: true}}},
                    {value: "ConditionTitle", style: {font: {bold: true}}},
                    {value: "Type", style: {font: {bold: true}}},
                    {value: "Operation", style: {font: {bold: true}}},
                    {value: "Value", style: {font: {bold: true}}},
                    {value: "ApproveLevel", style: {font: {bold: true}}},
                    {value: "ApproveLevelText", style: {font: {bold: true}}},
                    {value: "SignLevel", style: {font: {bold: true}}},
                    {value: "SignLevelText", style: {font: {bold: true}}},
                    {value: "ReportLevel", style: {font: {bold: true}}},
                    {value: "ReportLevelText", style: {font: {bold: true}}},
                    {value: "Remark", style: {font: {bold: true}}},
                    {value: "Comment", style: {font: {bold: true}}}
                ],
                [
                    {value: ""},
                    {value: ""},
                    {value: this.props.book.BookCode},
                ]
            ]    
        }];
        
        return (
            <ExcelFile hideElement={true} filename={filename}>
                <ExcelSheet dataSet={multiDataSet} name="Doa"/>
            </ExcelFile>
        );
    }

    onOpenRef=()=>{
        this.setState({isOpenRef:true});
    }

    onRequestNoChange=(v)=>{
        this.setState({searchReqNo:v});
    }

    onNoteChange=(v)=>{
        this.setState({searchNote:v});
    }

    onSearchReference = async () => {
        try {
            const res = await api.get(`${uri.GET_REFERENCE_REQUEST}?book=${this.props.book.BookCode}&note=${this.state.searchNote}&requestNo=${this.state.searchReqNo}`);
            if (res.status === 200 ) {
                this.setState({referOriginalDataList:res.data, 
                    referDataList:_.uniqBy(res.data, 'RequestID'),
                    currentPage:1
                });
            }
        } catch (ex) {
            this.setState({referOriginalDataList:[], referDataList:[]});
        }
    }

    onHandleChecked = (id, e) => {
        let newData = this.state.referDataList.map((obj) =>{
            if(obj.RequestID === id){
                obj.IsChecked = e.target.checked;
            }
            return obj;
        });
        this.setState({referDataList: newData});
    }

    onApproveRef = () => {
        let checkedList = [];
        let ret = this.state.topicList.map((obj)=>{
            this.state.referDataList.map((obj2)=>{
                if(obj2.IsChecked && !obj.IsLocked){
                    this.state.referOriginalDataList.map((obj3)=>{
                        if(obj2.RequestID === obj3.RequestID){
                            if(obj.TopicRefID === obj3.ReferenceID){
                                obj.IsChecked = true;
                                checkedList.push(obj);
                            }
                            //  if(obj.ConditionRefID === null){
                            //     if(obj.TopicRefID === obj3.ReferenceID){
                            //         obj.IsChecked = true;
                            //         checkedList.push(obj);
                            //     }
                            //  }else{
                            //     if(obj.ConditionRefID === obj3.ReferenceID){
                            //         obj.IsChecked = true;
                            //         checkedList.push(obj);
                            //     }
                            //  }
                        }
                    })
                }
            });
            return obj;
        });
        if(checkedList.length > 0){
            this.setState({topicList: ret, selectedTopicList: checkedList});
        }
        this.onCloseConfirm();
    }
    onShowSizeChange = (current, pageSize) => {
        this.setState({ currentPage:current });
      }
    render() {
        const indexOfLastPost = this.state.currentPage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.state.referDataList.slice(indexOfFirstPost, indexOfLastPost);
        return (
            <div className="flex-v home">
                <div className="flex-v flex-1">
                    <ManageDoaHeader text={`${this.props.book.BookName} (${this.props.type})`} isEdit={this.checkRoleEditBook()} onEdit={this.onEditTopic} onOpenRef={this.onOpenRef} onCloseRef={this.onCloseConfirm} />
                    <div className="ml-8 mr-8">
                        {this.state.subjectList.length === 0 ?
                            <div className="card not-found">
                                Not Found
                        </div> :
                            this.state.subjectList.map((subject, i) => {
                                return (
                                    <div key={i} className="card pointer mt-8" style={{ overflow: 'scroll' }}>
                                        <div className="pl-8 pr-8" style={{ width: `${((this.state.permissionWidth)+this.state.cardWidth*2)+this.state.valueWidth+40}px` ,minWidth:`${1355}px`}}>
                                        {/* <div className="pl-8 pr-8" style={{ minWidth: `1355px` }}> */}
                                            <div onClick={() => this.onSubjectSelected(subject)} className="flex-h flex-between" id={subject.KeyTmp}>
                                                <h3 className="ml-16 pt-8 pb-8">{subject.SubjectTitle}</h3>
                                                {(this.checkRoleEditBook() && this.state.selected === subject.SubjectTitle && this.hasSelectableTopic(subject.SubjectID)) &&
                                                    <button onClick={(e) => this.onToggleSelectAll(e, subject.SubjectID)} className="button is-small is-info mr-8">
                                                        {this.isSubjectAllSelected(subject.SubjectID) ? 'Deselect all' : 'Select all'}
                                                    </button>
                                                }
                                            </div>
                                            {this.state.selected === subject.SubjectTitle &&
                                                <div>{this.header()}</div>
                                            }
                                            {this.state.selected === subject.SubjectTitle && this.state.topicList.map((topic, i) => {
                                                if (subject.SubjectTitle === topic.SubjectTitle && !topic.IsCondition)
                                                    return (
                                                        <div key={topic.KeyTmp} className={`${!topic.TopicNo.includes('.') ? "mt-24 bt" : ""}`}>
                                                            {(((this.state.hilight === `${topic.TopicNo} ) ${topic.TopicTitle}`) || (this.state.hilight.includes(`${topic.TopicNo} ) ${topic.TopicTitle}`))) && i !== 0) &&
                                                                <div>{this.header()}</div>
                                                            }
                                                            {/* onClick={() => this.hilight(`${topic.TopicNo} ) ${topic.TopicTitle}`)} */}
                                                            <div onClick={() => this.hilight(`${topic.TopicNo} ) ${topic.TopicTitle}`)} style={{ borderBottom: '1px solid #ddd', borderLeft: '1px solid #ddd', borderRight: '1px solid #ddd', alignItems: 'inherit' }} className={`flex-h flex-between ${this.state.hilight === `${topic.TopicNo} ) ${topic.TopicTitle}` && 'bg-hilight'}`}>
                                                                <div className="flex-h flex-center" style={{ minWidth: '202px', justifyContent:'left' }}>
                                                                    
                                                                    {( this.checkRoleEditBook() && !topic.IsLocked) && <input className="ml-8 button-edit-small" onChange={(e) => this.handleCheckboxChange(e, topic.KeyTmp)} type="checkbox" checked={topic.IsChecked} />}
                                                                    {( this.checkRoleEditBook() && topic.IsLocked) && <img className="ml-8 button-edit" src={lockImg} alt={topic.LockBy} title={topic.LockBy} onClick={()=>this.onClickLock(topic.LockBy, topic.DisplayLockDate)} />}
                                                                    <h5 dangerouslySetInnerHTML={{ __html: `${topic.TopicNo} ) ${topic.TopicTitle}` }} style={{ alignSelf: 'center', margin: '4px 8px' }} title={topic.Type === 'A'?util.numberWithCommas(topic.Value):''}></h5>
                                                                </div>
                                                                {this.state.selected === subject.SubjectTitle &&
                                                                    <div className="flex-h">
                                                                        
                                                                        {topic.Remark !== null ?
                                                                            // <div className="flex-h flex-center" style={{ width: `${30 * this.state.permissionList.length}px`, borderLeft: '1px solid #ddd' }}>
                                                                            <div className="flex-h flex-center" style={{ width:`${this.state.permissionWidth}px`, borderLeft: '1px solid #ddd' }}>
                                                                                <h5>{topic.Remark}</h5>
                                                                            </div>
                                                                            :
                                                                            this.state.permissionList.map((permission, i) => {
                                                                                if (Number(topic.Approval) === Number(permission.PermissionSequence) && Number(topic.Sign) === Number(permission.PermissionSequence) && Number(topic.Report) === Number(permission.PermissionSequence))
                                                                                    return this.assignFunc(topic, 'ASR', i, permission)
                                                                                else if (Number(topic.Approval) === Number(permission.PermissionSequence) && Number(topic.Sign) === Number(permission.PermissionSequence))
                                                                                    return this.assignFunc(topic, 'AS', i, permission)
                                                                                else if (Number(topic.Sign) === Number(permission.PermissionSequence) && Number(topic.Report) === Number(permission.PermissionSequence))
                                                                                    return this.assignFunc(topic, 'SR', i, permission)
                                                                                else if (Number(topic.Approval) === Number(permission.PermissionSequence) && Number(topic.Report) === Number(permission.PermissionSequence))
                                                                                    return this.assignFunc(topic, 'AR', i, permission)
                                                                                else if (Number(topic.Approval) === Number(permission.PermissionSequence))
                                                                                    return this.assignFunc(topic, 'A', i, permission)
                                                                                else if (Number(topic.Sign) === Number(permission.PermissionSequence))
                                                                                    return this.assignFunc(topic, 'S', i, permission)
                                                                                else if (Number(topic.Report) === Number(permission.PermissionSequence))
                                                                                    return this.assignFunc(topic, 'R', i, permission)
                                                                                else
                                                                                    return (
                                                                                        <div key={i} className="pl-8 pr-8" style={{width: permission.PermissionName !== null ?10 * permission.PermissionName.length<30?'30px':  `${10 * permission.PermissionName.length}px` : '30px', borderLeft: '1px solid #ddd' }}>
                                                                                            &nbsp;
                                                                                        </div>
                                                                                    );
                                                                            })}
                                                                        <div className="pl-8 pr-8  flex-h" style={{ width: '300px', borderLeft: '1px solid #ddd', borderRight: '1px solid #ddd', alignItems: 'center' }}>
                                                                            <h5>{topic.Comments}</h5>
                                                                        </div>
                                                                        {this.checkRoleEditBook()&&<div className="flex-h" style={{ width: '43px', alignItems: 'center', display: 'block', textAlign: 'center', marginTop:'auto', marginBottom: 'auto'  }}>
                                                                            <h5>{topic.Active ?<img className="button-edit" src={correctImg} alt="Active" title="Active" />:<img className="button-edit" src={incorrectImg} alt="Inactive" title="Inactive" />}</h5>
                                                                        </div>}
                                                                        {this.checkRoleEditBook()&&<div className="pl-2  flex-h" style={{ width: '67px', borderLeft: '1px solid #ddd', alignItems: 'center' }}>
                                                                            <h5>{topic.DisplayDate}</h5>
                                                                        </div>}
                                                                        {this.checkRoleEditBook()&&<div className="pl-2   flex-h" style={{ width: '80px', borderLeft: '1px solid #ddd', alignItems: 'center' }}>
                                                                            <h5>{topic.UserID}</h5>
                                                                        </div>}
                                                                        <div className="pl-2  flex-h" style={{ width: '50px', borderLeft: `${this.checkRoleEditBook()?'1':'0'}px solid #ddd`, alignItems: 'center', justifyContent: 'center' }}>
                                                                            <h5>{topic.Type === "-" ? "": topic.Type}</h5>
                                                                        </div>
                                                                        <div className="pl-2  flex-h" style={{ width: '60px', borderLeft: '1px solid #ddd', alignItems: 'center', justifyContent: 'center' }}>
                                                                            <h5>{topic.Operation === "-" ? "" : topic.Operation}</h5>
                                                                        </div>
                                                                        <div className="pl-2  flex-h" style={{ width: `${this.state.valueWidth}px`, borderLeft: '1px solid #ddd', alignItems: 'center', justifyContent: 'right' }}>
                                                                            <h5 title={topic.Type === 'A'?util.numberWithCommas(topic.Value):''}>{topic.Value === "-" ? "" : topic.Value}</h5>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    );
                                                if(subject.SubjectTitle === topic.SubjectTitle && topic.IsCondition)
                                                    return(
                                                        <div key={topic.KeyTmp}>
                                                            <div onClick={() => this.hilight(`${topic.TopicNo} ) ${topic.TopicTitle} ${topic.CondTitle} ${i}`)} className={`flex-h flex-between ${this.state.hilight === `${topic.TopicNo} ) ${topic.TopicTitle} ${topic.CondTitle} ${i}` && 'bg-hilight'}`} style={{ borderBottom: '1px solid #ddd', borderLeft: '1px solid #ddd', borderRight: '1px solid #ddd', alignItems: 'inherit' }} >
                                                                <h5 className={`${this.checkRoleEditBook() && topic.IsCondition ? "ml-52" : "ml-16"}`} style={{ alignSelf: 'center', minWidth: `${this.checkRoleEditBook()?'150px':'186px'}` }} title={topic.Type === 'A'?util.numberWithCommas(topic.Value):''}>{topic.CondTitle}</h5>
                                                                <div style={{ height: `${this.checkRemarkForHeight(topic.Comments)}px` }} className="flex-h">
                                                                    
                                                                    {topic.Remark !== null ?
                                                                        // <div className="flex-h flex-center" style={{ width: `${30 * this.state.permissionList.length}px`, borderLeft: '1px solid #ddd' }}>
                                                                        <div className="flex-h flex-center" style={{ width:`${this.state.permissionWidth}px`, borderLeft: '1px solid #ddd' }}>
                                                                            <h5>{topic.Remark}</h5>
                                                                        </div>
                                                                        :
                                                                        this.state.permissionList.map((permission, i) => {
                                                                            if (Number(topic.Approval) === Number(permission.PermissionSequence) && Number(topic.Sign) === Number(permission.PermissionSequence) && Number(topic.Report) === Number(permission.PermissionSequence))
                                                                                return this.assignFunc(topic, 'ASR', i, permission)
                                                                            else if (Number(topic.Approval) === Number(permission.PermissionSequence) && Number(topic.Sign) === Number(permission.PermissionSequence))
                                                                                return this.assignFunc(topic, 'AS', i, permission)
                                                                            else if (Number(topic.Sign) === Number(permission.PermissionSequence) && Number(topic.Report) === Number(permission.PermissionSequence))
                                                                                return this.assignFunc(topic, 'SR', i, permission)
                                                                            else if (Number(topic.Approval) === Number(permission.PermissionSequence) && Number(topic.Report) === Number(permission.PermissionSequence))
                                                                                return this.assignFunc(topic, 'AR', i, permission)
                                                                            else if (Number(topic.Approval) === Number(permission.PermissionSequence))
                                                                                return this.assignFunc(topic, 'A', i, permission)
                                                                            else if (Number(topic.Sign) === Number(permission.PermissionSequence))
                                                                                return this.assignFunc(topic, 'S', i, permission)
                                                                            else if (Number(topic.Report) === Number(permission.PermissionSequence))
                                                                                return this.assignFunc(topic, 'R', i, permission)
                                                                            else
                                                                                return (
                                                                                    <div key={i} className="pl-8 pr-8" style={{ width: permission.PermissionName !== null ?10 * permission.PermissionName.length<30?'30px': `${10 * permission.PermissionName.length}px` : '30px', borderLeft: '1px solid #ddd' }}>

                                                                                    </div>
                                                                                );
                                                                        })}
                                                                    <div className="pl-8 pr-8 flex-h" style={{ width: '300px', borderLeft: '1px solid #ddd', borderRight: '1px solid #ddd', alignItems: 'center' }}>
                                                                        <h5>{topic.Comments}</h5>
                                                                    </div>
                                                                    {this.checkRoleEditBook()&&<div className="flex-h" style={{ width: '43px', alignItems: 'center', display: 'block', textAlign: 'center', marginTop:'auto', marginBottom: 'auto' }}>
                                                                        <h5>{topic.Active ?<img className="button-edit" src={correctImg} alt="Active" title="Active" />:<img className="button-edit" src={incorrectImg} alt="Inactive" title="Inactive" />}</h5>
                                                                    </div>}
                                                                    {this.checkRoleEditBook()&&<div className="pl-2  flex-h" style={{ width: '67px', borderLeft: '1px solid #ddd', alignItems: 'center' }}>
                                                                        <h5>{topic.DisplayDate}</h5>
                                                                    </div>}
                                                                    {this.checkRoleEditBook()&&<div className="pl-2   flex-h" style={{ width: '80px', borderLeft: '1px solid #ddd', alignItems: 'center' }}>
                                                                        <h5>{topic.UserID}</h5>
                                                                    </div>}
                                                                    <div className="pl-2  flex-h" style={{ width: '50px', borderLeft: `${this.checkRoleEditBook()?'1':'0'}px solid #ddd`, alignItems: 'center', justifyContent: 'center' }}>
                                                                        <h5>{topic.Type === "-" ? "": topic.Type}</h5>
                                                                    </div>
                                                                    <div className="pl-2  flex-h" style={{ width: '60px', borderLeft: '1px solid #ddd', alignItems: 'center', justifyContent: 'center' }}>
                                                                        <h5>{topic.Operation === "-" ? "" : topic.Operation}</h5>
                                                                    </div>
                                                                    <div className="pl-2  flex-h" style={{ width: `${this.state.valueWidth}px`, borderLeft: '1px solid #ddd', alignItems: 'center', justifyContent: 'right' }}>
                                                                        <h5 title={topic.Type === 'A'?util.numberWithCommas(topic.Value):''}>{topic.Value === "-" ? "" : topic.Value}</h5>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                            })}
                                        </div>
                                    </div>
                                );
                            })}
                    </div>
                </div>
                <div className="p-8 text-center">
                    <button onClick={() => this.onBackPressed()} className="button is-info mr-8 mt-8">Back</button>
                    <button onClick={() => this.onOpenRef()} className="button is-primary mr-8 mt-8">Reference</button>
                    {(this.checkRoleEditBook())&&<button onClick={() => this.onEditTopic()} className="button is-success mt-8">Checkout</button>}
                </div>
                {this.state.isDownloadExcel && this.downloadExcelForEdit()}
                {this.state.isDownloadTemplate && this.downloadExcelForAdd()}
                <NoteModal isOpen={this.state.isOpenEdit} message={this.state.messageConfirm} onConfirm={this.onSubmit} onClose={this.onCloseConfirm} text={this.state.textConfirm} />
                {/* <ConfirmDialogModal isOpen={this.state.isOpenEdit} message={this.state.messageConfirm} onConfirm={this.onSubmit} onClose={this.onCloseConfirm} text={this.state.textConfirm} /> */}
                <ConfirmDialogModal isOpen={this.state.isOpenAdd} message={this.state.messageConfirm} onConfirm={this.onDownloadTemplateAdd} onClose={this.onCloseConfirm} text={this.state.textConfirm} />
                <AlertModal isOpen={this.state.isOpenMessage} message={this.state.message} onClose={this.onCloseAlert} type={this.state.typeAlert} />
                <Modal
                    isOpen={this.state.isOpenRef}
                    onRequestClose={this.onCloseConfirm}
                    style={customStyles}>
                        <div className="flex-v">
                            <div className="flex-v flex-1">
                                <div className="flex-v flex-1 pl-24 pr-24">
                                <div
                                    className="flex-v bg-grey-lighter pl-16 pr-16 pb-16 mt-16"
                                    style={{ borderRadius: "10px" }}
                                >
                                    <FormInput
                                        value={this.state.searchReqNo}
                                        onValueChange={this.onRequestNoChange}
                                        type="text"
                                        placeholder="Request No"
                                    />
                                    <FormInput
                                        value={this.state.searchNote}
                                        onValueChange={this.onNoteChange}
                                        type="text"
                                        placeholder="Note"
                                    />
                                    <div className=" flex-h mt-16 center buttons" >
                                        <button onClick={() => this.onSearchReference()} className="button is-info center" >
                                            Search
                                        </button>
                                        <button onClick={() => this.onApproveRef()} className="button is-success center" >
                                            Ok
                                        </button>
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div className="flex-v text-center p-16 mt-8">
                                {this.state.referDataList.length === 0 ?<div>Data not found.</div>:
                                <div className="table-container">
                                    <table className="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
                                        <thead>
                                            <tr>
                                                <th>
                                                    #
                                                </th>
                                                <th>
                                                    Request No
                                                </th>
                                                <th>
                                                    Note
                                                </th>
                                                <th>
                                                    Creator
                                                </th>
                                            </tr>
                                            </thead>
                                            <tfoot>
                                            <tr>
                                                <td colSpan="4" style={{textAlign:'center'}}>
                                                <Pagination className="ant-pagination" 
                                                    onChange={this.onShowSizeChange}
                                                    defaultCurrent={1} 
                                                    pageSize={this.state.postsPerPage} 
                                                    total={this.state.referDataList.length} />
                                                </td>
                                            </tr>
                                            </tfoot>
                                            <tbody>
                                                {currentPosts.map((item, i) =>{
                                                    return (
                                                        <tr key={`reference-`+item.ReferenceID+item.RequestID}>
                                                            <td>
                                                            <input className="button-edit-small" onChange={(e) => this.onHandleChecked(item.RequestID, e)} type="checkbox" checked={item.IsChecked} />
                                                            </td>
                                                            <td>{item.RequestNo}</td>
                                                            <td>{item.Note}</td>
                                                            <td>{item.CreatorName}</td>
                                                        </tr>
                                                    );
                                                })}
                                            
                                        </tbody>
                                    </table>
                                </div>
                                }
                            </div>
                        </div>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isAuthen: state.auth.isAuthen,
        topicList: state.doa.queryDoaList.filter(item => item.SubjectTypeTitle === state.doa.type),
        conditionList: state.doa.queryConditionList,
        type: state.doa.type,
        doa: state.doa.doa,
        book: state.doa.queryBook,
        auth: state.auth
    }
}
export default connect(mapStateToProps,{setLoading})(ManageDoa);
